export function createChartLayoutDriver(root, syncPanels) {
  const axes = [];
  return {
    prepare() {
      const visit = entity => {
        if (entity.isType('Axis')) {
          axes.push([entity, entity.get('interpolationDuration')]);
          // The compositor owns layout motion; an additional 600ms axis tween
          // would keep moving candles after the outer animation completes.
          entity.set('interpolationDuration', 0);
        }
        entity.children?.each(visit);
      };
      visit(root.container);
    },
    restore() {
      axes.splice(0).forEach(([axis, duration]) => {
        if (!axis.isDisposed()) axis.set('interpolationDuration', duration);
      });
    },
    resize() {
      if (root.isDisposed()) return;
      const skipRenderFrame = root.skipRenderFrame;
      root.skipRenderFrame = true;
      try { root.resize(); }
      finally { root.skipRenderFrame = skipRenderFrame; }
    },
    flushLayout() {
      if (root.isDisposed()) return;
      // amCharts 5.20: resize clears the backing store before its next ticker.
      // Drain layout only (never the animation ticker), with a hard bound, then
      // paint once. Keep this internal integration isolated and regression-tested.
      for (let pass = 0; pass < 4; pass++) {
        root._runDirties();
        syncPanels?.();
        if (!root._isDirty && !root._isDirtyParents &&
            !Object.keys(root._dirtyBounds).length && !Object.keys(root._dirtyPositions).length) break;
      }
      root._render();
    },
  };
}
